import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-0 elevation-1 text-h5 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "mt-1 py-2 text-caption d-flex justify-center align-center gap-2"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center flex-column",
  style: {"height":"50vh"}
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column align-center"
}
const _hoisted_5 = { class: ".pdf-container" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex justify-center align-center flex-column",
  style: {"height":"50vh"}
}
const _hoisted_7 = {
  key: 0,
  class: "mt-10 text-h6 text-center"
}
const _hoisted_8 = {
  key: 3,
  class: "d-flex justify-center align-center flex-column",
  style: {"height":"50vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFView = _resolveComponent("PDFView")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_motion_pop_visible = _resolveDirective("motion-pop-visible")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentFrame?.template?.pdfSource)
      ? (_openBlock(), _createBlock(_component_PDFView, {
          key: 0,
          source: _ctx.currentFrame?.template?.pdfSource,
          page: -1,
          onLoaded: _ctx.onPdfLoaded
        }, null, 8, ["source", "onLoaded"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode("Designer ")),
        _createVNode(_component_v_icon, { class: "mr-2" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-brush-outline")
          ])),
          _: 1,
          __: [0]
        }),
        (_ctx.currentFrame?.template?.pdfSource)
          ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: "mr-2",
              size: "small",
              onClick: _ctx.generateAgainSuggestions
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("mdi-sync")
              ])),
              _: 1,
              __: [1]
            }, 8, ["onClick"])), [
              [_directive_tooltip, 'Neu generieren', "end"]
            ])
          : _createCommentVNode("", true)
      ]),
      (_ctx.currentFrame?.template?.pdfSource != undefined)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "font-weight-light" }, "Empfehlung:", -1)),
            _createVNode(_component_v_chip, {
              class: "mx-1",
              color: "green-darken-2",
              small: ""
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Am besten")
              ])),
              _: 1,
              __: [3]
            }),
            _createVNode(_component_v_chip, {
              class: "mx-1",
              color: "orange-darken-3",
              small: ""
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Mittel")
              ])),
              _: 1,
              __: [4]
            }),
            _createVNode(_component_v_chip, {
              class: "mx-1",
              color: "red-darken-3",
              small: ""
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Niedig")
              ])),
              _: 1,
              __: [5]
            })
          ])), [
            [_directive_motion_pop_visible]
          ])
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_sheet, {
      height: "550px",
      "max-height": "550px",
      class: "overflow-y-auto hidden-scrollbar d-flex flex-column bg-blue-grey-lighten-5"
    }, {
      default: _withCtx(() => [
        (_ctx.isInProcessOfNewGenerating)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: 70,
                width: 7,
                color: "green-lighten-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-cogs")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-10 text-h6 text-center" }, "Layout-Vorschläge werden aktualisiert...", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentFrame?.template?.pdfSource != undefined && !_ctx.isInProcessOfNewGenerating)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: page,
                  class: "photo-item mb-4"
                }, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_v_chip, {
                      color: _ctx.getScoreColor(_ctx.currentFrame.template.slideTemplate[page].score),
                      class: "my-n2",
                      label: "",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Score: " + _toDisplayString(_ctx.currentFrame.template.slideTemplate[page].score === 1 ? '1,0' : _ctx.currentFrame.template.slideTemplate[page].score), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createVNode(_component_PDFView, {
                      class: "mt-2 elevation-10 rounded-xl h-auto",
                      style: { cursor: 'pointer' },
                      source: _ctx.currentFrame?.template?.pdfSource,
                      page: page,
                      scale: 1.5,
                      onClick: ($event: any) => (_ctx.selectedSuggestedLayout(page))
                    }, null, 8, ["source", "page", "onClick"])
                  ])), [
                    [_directive_motion_pop_visible]
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isInProcess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: 70,
                width: 7,
                color: "blue-grey-darken-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-cogs")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ]),
                _: 1
              }),
              (_ctx.isInProcess)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Layout-Vorschläge werden generiert... "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isInProcess && !_ctx.currentFrame?.template?.pdfSource)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_btn, {
                class: "ma-2 pa-2 elevation-5 font-weight-light",
                size: "large",
                border: "dashed thin",
                onClick: _ctx.generateLayoutsSuggestions
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "#1DE9B6" }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-creation-outline")
                    ])),
                    _: 1,
                    __: [10]
                  })
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "#FFC107" }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("mdi-creation-outline")
                    ])),
                    _: 1,
                    __: [11]
                  })
                ]),
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createTextVNode(" Generieren "))
                ]),
                _: 1,
                __: [12]
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}